import axios from 'axios';
import config from '../config.js';

const client = axios.create({
    baseURL: config.apiURL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

client.interceptors.request.use(async function requestConfig(config) {
    if(localStorage.getItem('token')) {
        config.headers['Authorization'] = localStorage.getItem('token');
    }

    return config;
});

export default client;
